
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/zakelijk/partner-worden",
      function () {
        return require("private-next-pages/zakelijk/partner-worden.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/zakelijk/partner-worden"])
      });
    }
  